import React from 'react';

// Los estilos de esta sección viven en PisoSpcPremium.css (importado en la página).

const VideoSpcPremium = () => {
  return (
    <section className="video-section spc-section">
      <div className="container">
        <div className="row justify-content-center mb-5 mb-lg-8">
          <div className="col-lg-8 text-center">
            <div className="mb-1-9 mb-lg-2-5 title-style5">
              <span className="sub-title">Conoce el producto</span>
              <h2 className="display-5 lh-1 font-weight-800 mb-0">
                Piso SPC Luxury en Acción
              </h2>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="video-container wow fadeInUp" data-wow-delay="200ms">
              <iframe
                src="https://www.youtube.com/embed/IYR4y_Fora8?si=TcSnZHDCE3hgGW0a"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                referrerPolicy="strict-origin-when-cross-origin"
                allowFullScreen
                loading="lazy"
                className="video-iframe"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default VideoSpcPremium;